import Helmet from '@/components/base/Helmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import DailyCompetition from './components/DailyCompetition';
import RealTimeTracking from './components/RealTimeTracking';
import CommentsSection from './components/CommentsSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料爆料吃瓜网',
  url: 'http://mengwenquda.cn/',
  description: '黑料爆料吃瓜网每日推送全网热门黑料爆料与黑料爆料每日大赛，覆盖51吃瓜黑料爆料、17c吃瓜黑料爆料，网红塌房现场、明星聊天记录泄露、博主反差视频一网打尽。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://mengwenquda.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黑料爆料吃瓜网',
  url: 'http://mengwenquda.cn/',
  description: '国内领先的黑料爆料资讯聚合平台',
  email: 'hello@mengwenquda.cn',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    streetAddress: '望京SOHO',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '黑料爆料吃瓜网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '黑料爆料吃瓜网是国内领先的黑料爆料资讯聚合平台，覆盖51吃瓜黑料爆料、17c吃瓜黑料爆料、网红塌房、明星聊天记录泄露、博主反差视频等热门内容。',
      },
    },
    {
      '@type': 'Question',
      name: '如何订阅黑料爆料吃瓜网的最新内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '在网站底部的订阅区域输入您的邮箱地址，即可免费订阅黑料爆料吃瓜网的最新爆料推送，第一时间获取全网热门黑料。',
      },
    },
    {
      '@type': 'Question',
      name: '每日大赛是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '每日大赛是黑料爆料吃瓜网的王牌栏目，每天评选最劲爆的黑料爆料，用户可以参与投票选出心目中的"今日瓜王"。',
      },
    },
  ],
};

function SchemaScript({ data }: { data: Record<string, unknown> }) {
  return (
    <Helmet>
      {`<script type="application/ld+json">${JSON.stringify(data)}</script>`}
    </Helmet>
  );
}

export default function Home() {
  return (
    <>
      <Helmet title="黑料爆料吃瓜网 - 全网热门黑料爆料与每日大赛，51吃瓜黑料爆料实时追踪" />
      <SchemaScript data={websiteSchema} />
      <SchemaScript data={orgSchema} />
      <SchemaScript data={faqSchema} />

      <Navbar />

      <main>
        <article>
          <HeroSection />
        </article>
        <section>
          <FeaturedGrid />
        </section>
        <section>
          <RealTimeTracking />
        </section>
        <section>
          <DailyCompetition />
        </section>
        <section>
          <CommentsSection />
        </section>
        <section>
          <CTASection />
        </section>
      </main>

      <Footer />
    </>
  );
}